import { FC } from 'react';

import styled from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';

interface IHeaderLoadingProps extends IBaseProps {
  hasStoreSelection: boolean;
}

const styleLoadingIndicator = (Loader: FC<IBaseProps>) => styled(Loader)`
  position: absolute;
  bottom: ${(p: IHeaderLoadingProps) => (p.hasStoreSelection ? '32px' : '0')};
`;

export default styleLoadingIndicator;
